import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import React from 'react';

import style from '../setup-body/style.module.less';

export const CircleToCheckIcon = () => {
  return (
    <div className={style['circle-to-check-wrapper']}>
      <FontAwesomeIcon className={style['check-icon']} icon={faCheck} />
    </div>
  );
};
